import { Typography } from "@mui/material";
import React from "react";
import AuthContainer from "../../../components/containers/AuthContainer";
import LoginForm from "./LoginForm";

const LoginPage = () => {



  return (
    <AuthContainer>
      {/* <Container maxWidth={"sm"}> */}
      <Typography
        variant={"h1"}
        fontSize={"2.5rem"}
        fontWeight={700}
        color={"text.davyGrey"}
        textAlign={"center"}
      >
        Login
      </Typography>
      <Typography
        variant={"body1"}
        fontWeight={300}
        color={"text.coolGrey"}
        textAlign={"center"}
      >
        Welcome to{" "}
        <span style={{ color: "#000000", fontWeight: "bold" }}>Trust</span>{" "}
        Business system, Please give us user id and password
      </Typography>

      {/* Login Form */}

      <LoginForm />
      {/* </Container> */}
    </AuthContainer>
  );
};

export default LoginPage;
